var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronArrowRightCircle = function SvgChevronArrowRightCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.163 0 0 7.163 0 16s7.163 16 16 16 16-7.164 16-16S24.836 0 16 0m0 30C8.28 30 2 23.72 2 16S8.28 1.969 16 1.969 30 8.28 30 16s-6.28 14-14 14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.808 8.271a.994.994 0 0 0-1.414 0 1.017 1.017 0 0 0 0 1.429l6.195 6.285-6.196 6.285a1.017 1.017 0 0 0 0 1.429.994.994 0 0 0 1.414 0l6.9-6.999a1.037 1.037 0 0 0 0-1.429z"
  }))));
};
export default SvgChevronArrowRightCircle;